import {
  AmplitudeContext,
  AmplitudeEventConstants,
} from '@homebot/shared-util-quartermaster'
import { setFilter } from '../../../../actions/filters'
import { defineMessages, useIntl } from 'react-intl'
import { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectFilter } from '../../../../store/selectors/filters'

import styles from './ListingsSort.module.scss'

const SORT_VALUES = {
  sqftAsc: 'sqft_total, asc',
  sqftDesc: 'sqft_total, desc',
  priceAsc: 'price_cents, asc',
  priceDesc: 'price_cents, desc',
  daysOnMarket: 'days_on_market, asc',
}

const LISTINGS_SORT_SELECT = defineMessages({
  daysOnMarket: {
    id: 'HomeSearch.listings.order.daysOnMarket',
    defaultMessage: 'Newest listings',
  },
  priceOptionLowest: {
    id: 'HomeSearch.listings.order.lowest',
    defaultMessage: 'Lowest price',
  },
  priceOptionHighest: {
    id: 'HomeSearch.listings.order.highest',
    defaultMessage: 'Highest price',
  },
  squareFeetOptionSmallest: {
    id: 'HomeSearch.listings.order.smallest',
    defaultMessage: 'Smallest sq. ft.',
  },
  squareFeetOptionLargest: {
    id: 'HomeSearch.listings.order.largest',
    defaultMessage: 'Largest sq. ft.',
  },
})

const ListingsSort = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const filter = useSelector(selectFilter)
  const { ampli } = useContext(AmplitudeContext)
  const [sortValue, setSortValue] = useState('')

  const onChange = event => {
    const value = event.target.value

    if (value === SORT_VALUES.priceAsc) {
      ampli?.searchSort({
        search_sort_updated:
          AmplitudeEventConstants.SORT_LISTINGS_BY_PRICE_HIGH,
      })
    } else if (value === SORT_VALUES.priceDesc) {
      ampli?.searchSort({
        search_sort_updated: AmplitudeEventConstants.SORT_LISTINGS_BY_PRICE_LOW,
      })
    } else if (value === SORT_VALUES.sqftAsc) {
      ampli?.searchSort({
        search_sort_updated:
          AmplitudeEventConstants.SORT_LISTINGS_BY_SQFT_LARGE,
      })
    } else if (value === SORT_VALUES.sqftDesc) {
      ampli?.searchSort({
        search_sort_updated:
          AmplitudeEventConstants.SORT_LISTINGS_BY_SQFT_SMALL,
      })
    }

    const [key, val] = value.split(', ')
    dispatch(setFilter({ order: { [key]: val }, page: 1 }))
  }

  useEffect(() => {
    if (filter?.order) {
      const sortKey = Object.keys(filter.order)[0]
      setSortValue(`${sortKey}, ${filter.order[sortKey]}`)
    }
  }, [filter])

  return (
    <select
      onChange={event => onChange(event)}
      className={styles.listingsSort}
      data-qa='listingsSort'
      value={sortValue}
    >
      <option value={SORT_VALUES.daysOnMarket}>
        {intl.formatMessage(LISTINGS_SORT_SELECT.daysOnMarket)}
      </option>
      <option value={SORT_VALUES.priceAsc}>
        {intl.formatMessage(LISTINGS_SORT_SELECT.priceOptionLowest)}
      </option>
      <option value={SORT_VALUES.priceDesc}>
        {intl.formatMessage(LISTINGS_SORT_SELECT.priceOptionHighest)}
      </option>
      <option value={SORT_VALUES.sqftAsc}>
        {intl.formatMessage(LISTINGS_SORT_SELECT.squareFeetOptionSmallest)}
      </option>
      <option value={SORT_VALUES.sqftDesc}>
        {intl.formatMessage(LISTINGS_SORT_SELECT.squareFeetOptionLargest)}
      </option>
    </select>
  )
}

export default ListingsSort
